import { Instance, types } from "mobx-state-tree";
import { globalModule } from "../service-provider/GlobalModule";
import { registerGlobalService } from "../service-provider/ServiceRegistry";

const WarningLeavePageServiceModel = types
  .model({
    isDirty: types.optional(types.boolean, false),
    isSubmitting: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    setIsDirty: (isDirty: boolean) => {
      self.isDirty = isDirty;
    },
    setIsSubmitting: (isSubmitting: boolean) => {
      self.isSubmitting = isSubmitting;
    },
    reset: () => {
      self.isDirty = false;
      self.isSubmitting = false;
    },
  }));

export type WarningLeavePageService = Instance<typeof WarningLeavePageServiceModel>;
export const warningLeavePageService = WarningLeavePageServiceModel.create();

globalModule.warningLeavePageService = warningLeavePageService;
export default registerGlobalService(warningLeavePageService as WarningLeavePageService);
